import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import icClose from '@iconify/icons-ic/twotone-close';
import icDelete from '@iconify/icons-ic/twotone-delete';
import icAddAPhoto from '@iconify/icons-ic/twotone-add-a-photo';
import icKeyboardArrowRight from '@iconify/icons-ic/twotone-keyboard-arrow-right';
import { MatDialogRef } from '@angular/material/dialog';
import icSend from '@iconify/icons-ic/twotone-send';
import icAttachFile from '@iconify/icons-ic/twotone-attach-file';
import icImage from '@iconify/icons-ic/twotone-image';
import { Camera, CameraDirection, CameraResultType } from '@capacitor/camera';
import { fadeInUp400ms } from '../../../../@vex/animations/fade-in-up.animation';
import { UserStore } from '../../../stores/user.store';
import { CoronaTestResult } from '../../../entities/corona-test-result.entity';
import { CoronaTestResultFile } from '../../../entities/corona-test-result-file.entity';
import { AppMessageService } from '../../../services/message.service';
import { SpinnerService } from '../../../components/spinner/spinner.service';
import { SignatureComponent } from '../../../components/signature/signature.component';
import { CoronaService } from '../../../services/corona.service';
import { DbFile } from '../../../entities/db-file.entity';
import { HelperService } from '../../../services/helper.service';

@Component({
  selector: 'app-new-test-dialog',
  template: `
    <div class="flex items-center mb-1" mat-dialog-title>
      <p class="flex-auto text-lg font-medium">New Test Result</p>
      <button mat-dialog-close mat-icon-button type="button">
        <mat-icon [icIcon]="icClose" size="24px"></mat-icon>
      </button>
    </div>

    <mat-dialog-content>

      <div fxLayout="column" fxLayoutGap="16px" class="p-2 pb-4">
        <mat-radio-group fxLayout="row" fxLayoutGap="16px" [(ngModel)]="testResult.testPositive">
          <mat-radio-button color="primary" [value]="false">Negative</mat-radio-button>
          <mat-radio-button color="warn" [value]="true">Positive</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-form-field appearance="outline" class="block w-full" style="margin-top:15px">
        <mat-label>Test Date</mat-label>
        <input (click)="formDatepickerTestDateRef.open()"
               [matDatepicker]="formDatepickerTestDateRef"
               [(ngModel)]="testResult.testDate"
               [max]="today"
               matInput
               readonly>
        <mat-datepicker-toggle [for]="formDatepickerTestDateRef" matSuffix></mat-datepicker-toggle>
        <!--<mat-hint>Click on the input or the datepicker icon</mat-hint>-->
        <mat-datepicker #formDatepickerTestDateRef></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="block w-full">
        <mat-label>Comment (optional)</mat-label>
        <input matInput type="text" [(ngModel)]="testResult.comment"/>
      </mat-form-field>

      <!--<div class="vex-mail-compose-editor flex flex-col">
        <quill-editor [styles]="{ flex: '1 1 auto', display: 'flex', 'flex-direction': 'column' }"
                      class="flex-auto flex flex-col"></quill-editor>
      </div>-->

      <button class="text-secondary uppercase font-medium pt-2" mat-button type="button" (click)="addPicture()" style="margin-top: -10px;">
        <ic-icon [icon]="icAddAPhoto"
                 [inline]="true"
                 class="ltr:-ml-1 rtl:-mr-1 ltr:mr-2 rtl:ml-2"
                 size="24px"></ic-icon>
        <span class="text-s">Photo</span>
      </button>

      <!--<button class="text-secondary uppercase font-medium" mat-button type="button">
        <ic-icon [icon]="icAttachFile"
                 [inline]="true"
                 class="ltr:-ml-1 rtl:-mr-1 ltr:mr-2 rtl:ml-2"
                 size="24px"></ic-icon>
        <span class="text-s">File/Document</span>
      </button>-->

      <div *ngFor="let file of testResult.files, let i = index">
        <div @fadeInUp
             class="vex-mail-compose-attachment mt-4 mb-2 rounded-full border px-4 py-1 flex items-center hover:bg-hover transition duration-200 ease-in-out cursor-pointer relative"
             matRipple (click)="openImage(file)">
          <mat-icon class="flex-none text-primary" size="18px">attach_email</mat-icon>
          <p class="flex-auto ml-4 text-sm">{{file.file.name}}</p>
          <!--<p class="text-sm text-secondary mr-2 flex-none">{{file.size}}</p>-->
          <button (click)="removeFile(file)" class="flex-none w-8 h-8 leading-none" mat-icon-button type="button">
            <mat-icon class="my-color-grey" size="18px">delete</mat-icon>
          </button>
        </div>
      </div>

      <app-signature></app-signature>

    </mat-dialog-content>

    <mat-dialog-actions>

      <span class="flex-1"></span>

      <button (click)="save()" color="primary" mat-flat-button type="button">
        <span>Save</span>
        <ic-icon [icIcon]="icSend" [inline]="true" class="ml-2" size="16px"></ic-icon>
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: [
    './corona-new-test-dialog.component.scss'
  ],
  animations: [
    fadeInUp400ms
  ],
  encapsulation: ViewEncapsulation.None
})
export class CoronaNewTestDialogComponent implements OnInit {
  icClose = icClose;
  icDelete = icDelete;
  icSend = icSend;
  icAttachFile = icAttachFile;
  icImage = icImage;
  icAddAPhoto = icAddAPhoto;
  icKeyboardArrowRight = icKeyboardArrowRight;

  user = this.userStore.getUser();
  testResult: CoronaTestResult;
  imageCounter = 1;
  today = new Date();

  @ViewChild(SignatureComponent)
  private signatureComponent!: SignatureComponent;

  constructor(private cd: ChangeDetectorRef,
              private dialogRef: MatDialogRef<CoronaNewTestDialogComponent>,
              private userStore: UserStore,
              private appMessageService: AppMessageService,
              private coronaService: CoronaService,
              private spinner: SpinnerService,
              private helperService: HelperService
  ) { }

  ngOnInit(): void {
    const uploadDate = Date.now();
    this.testResult = {
      testDate: new Date(),
      comment: '',
      testPositive: false,
      files: [] as CoronaTestResultFile[]
    };
  }

  async addPicture() {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
      saveToGallery: true,
      presentationStyle: 'fullscreen',
      direction: CameraDirection.Rear,
      preserveAspectRatio: true,
      width: 1080
    });

    const imageUrl = image.dataUrl;

    this.testResult.files.push({
      ...new CoronaTestResultFile(),
      file: {content: imageUrl, name: Date.now() + '_' + this.imageCounter + '.jpg'} as DbFile
    });

    this.imageCounter++;

    console.log('Added file', this.testResult);
  }

  removeFile(file) {
    const index = this.testResult.files.findIndex(f => f.file.name === file.file.name); // find index in your array
    this.testResult.files.splice(index, 1); // remove element from array
  }

  openImage(file) {
    this.appMessageService.showImageDialog(file.content);
  }

  async save() {
    if (this.testResult.files.length === 0) {
      this.appMessageService.showInfoDialog('Please provide at least one photo of the test');
    }
    else if (!this.signatureComponent.done()) {
      this.appMessageService.showInfoDialog('Please provide a signature');
    }
    else {
      try {
        this.spinner.show();
        console.log('New test result', this.testResult);

        // Prevent time zones problems
        //this.testResult.testDate = dayjs(this.testResult.testDate).add(1, 'hours').toDate();

        this.testResult.signature = this.signatureComponent.returnImage();
        this.testResult.signature = await this.helperService.pngToJpg(this.testResult.signature);

        await this.coronaService.postTest(this.testResult);
        this.appMessageService.showToastSuccess('Stored');
        this.spinner.hide();
        this.close();
      }
      catch (e) {
        console.error(e);
        this.spinner.hide();
      }
    }
  }

  close() {
    this.dialogRef.close();
  }

}
